module.exports = __webpack_public_path__ + "static/img/156.8f931a56.png";